module.exports = __webpack_public_path__ + "static/media/INTEGRATION THROUGH IMAP - GMAIL.45deb254.png";